<template>

  <div class="padded">
    <h2><i class="fa fa-map-pin" />&nbsp;Localities</h2>

    <el-input
    placeholder="Filter keyword"
    v-model="filterText">
  </el-input>

  <el-tree
  ref="tree2"
  class="filter-tree"
  accordion
  :data="loc.regions"
  :props="defaultProps"
  :filter-node-method="filterNode">
  <span slot-scope="{ node, data }">
    <b :class="styleType(data.type)">{{ node.label }}</b>&nbsp;<small>{{data.type}}</small>
<!--
      <span class="pull-right">
        <el-button
          type="text"
          size="mini"
          @click="() => append(data)">
            Append
        </el-button>
        <el-button
          type="text"
          size="mini"
          @click="() => remove(node, data)">
          Delete
        </el-button>
      </span>
-->
</span>
</el-tree>

</div>

</template>

<script>

import {localityData} from '@/components/Data'

export default {

  watch: {
    filterText (val) {
      this.$refs.tree2.filter(val)
    }
  },

  methods: {
    styleType (type) {
      switch (type) {
        case 'Region': return 'text-danger'
        case 'State': return 'text-warning'
        case 'District Council': return 'text-primary'
        case 'Municipal Council': return 'text-primary'
        case 'City Council': return 'text-primary'
        default:
          return 'text-info'
      }
    },

    filterNode (value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },

    append (data) {
/*
      const newChild = {name: 'testtest', divisions: [] }
      if (!data.divisions) {
        this.$set(data, 'divisions', [])
      }
      data.children.push(newChild)
*/
    },

    remove (node, data) {
/*
      const parent = node.parent
      const divisions = parent.data.divisions || parent.data
      const index = divisions.findIndex(d => d.id === data.id)
      children.splice(index, 1)
*/
    },

    renderContent (h, { node, data, store }) {
      return (`
        <span class="custom-tree-node">
        <span>{node.label}</span>
        <span>
        <el-button size="mini" type="text" on-click={ () => this.append(data) }>Append</el-button>
        <el-button size="mini" type="text" on-click={ () => this.remove(node, data) }>Delete</el-button>
        </span>
        </span>`)
    }
  },

  data () {
    return {
      filterText: '',
      loc: localityData,
      defaultProps: {
        children: 'divisions',
        label: 'name',
        value: 'name'
      }
    }
  },

  mounted () {
    //    console.log(this.loc)
  }
}

</script>



// WEBPACK FOOTER //
// Locality.vue?ce637bb2